import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '../ui/alert-dialog';

interface ModalConfirmationInterface {
	displayModalConfirmation: boolean;
	setDisplayModalConfirmation: (value: boolean) => void;
	optionStore: { action?: string };
	callBackProceedMethodProp?: (...args: any[]) => void;
}

const confirmationDetails = [
	{ action: 'deleteChat', title: 'Delete', description: 'Are you sure you want to delete your chat room with this user?' },
	{ action: 'deleteGroupChat', title: 'Delete Group Chat', description: 'Are you sure you want to delete your group chatroom?' },
	{ action: 'deleteMessage', title: 'Delete Message', description: 'Are you sure you want to delete this message?' },
	{ action: 'leaveGroup', title: 'Leave Group', description: 'Are you sure you want to leave this group?' },
	{ action: 'reportGroup', title: 'Confirmation', description: 'Are you sure you want to submit this report?' },
	{ action: 'rejectInvitation', title: 'Reject Invitation', description: 'Are you sure you want to reject a chat invitation from this group or user?' },
	{ action: 'deleteAllChat', title: 'Delete all chat', description: 'Are you sure you want to delete all messages?' },
	{ action: 'reportUser', title: 'Report this User', description: 'Are you sure you want to submit this report?' },
	{ action: 'leavingPage', title: 'Leaving Page', description: 'You are about to leave this page. Any changes you made may not be saved. Are you sure you want to proceed?' },
	{ action: 'submitFeedbackConfirmation', title: 'Confirmation', description: 'Are you ready to submit your session and feedback?' },
];

export function ModalConfirmation({
	displayModalConfirmation,
	setDisplayModalConfirmation,
	optionStore,
	callBackProceedMethodProp,
}: ModalConfirmationInterface) {
	const originUrl = localStorage.getItem('originURL');
	const details =
		confirmationDetails.find((confirmation) => confirmation.action === optionStore.action) ||
		(optionStore.action === 'leavingFL'
			? {
				title: 'Leaving Chat App',
				description: `You will be redirected back to ${originUrl ? 'Programme overview' : 'FutureLab dashboard'}. Do you want to proceed?`,
			}
			: { title: 'Confirmation', description: 'Are you sure you want to proceed?' });

	const handleProceed = () => {
		setDisplayModalConfirmation(false);
		callBackProceedMethodProp?.();
	};

	return (
		<AlertDialog onOpenChange={setDisplayModalConfirmation} open={displayModalConfirmation}>
			<AlertDialogContent className="w-[calc(100%-2rem)] min-w-0 sm:max-w-sm">
				<AlertDialogHeader>
					<AlertDialogTitle>{details.title}</AlertDialogTitle>
				<AlertDialogDescription className="break-words">{details.description}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={() => setDisplayModalConfirmation(false)}>No</AlertDialogCancel>
					<AlertDialogAction onClick={handleProceed}>Yes</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
